export default function (http) {
    return {


        queryByPage(data) {
            return http.json({
                url: `/sku/roster/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        getInfo(data) {
            return http.json({
                url: `/sku/roster/get?id=${data.id}`,
                data
            })
        },

        getOne(data) {
            return http.json({
                url: `/sku/roster/getOne`,
                data
            })
        },

        getInfo2(data) {
            return http.json({
                url: `/sku/roster/get?id=1`,
                data
            })
        },
        outClazz(data) {
            return http.json({
                url: `/sku/roster/outClazz`,
                data
            })
        },

        delete(data) {
            return http.json({
                url: `/sku/roster/deleteOrder`,
                data
            })
        },
    }
}





// WEBPACK FOOTER //
// ./src/configure/http/api/enroll/enroll.js